module.exports = __webpack_public_path__ + "static/media/2.cc41e47b.jpg";